<template>
<div :style="coverStyle" class="search-structure-cover">
  <div class="cover-content">
    <div class="cover-head">
      <div>BATCH MODE</div>
      <div class="close-button" @click="hidden"><i class="el-icon-close"></i></div>
    </div>

    <div class="upload-smiles" v-show="step=='upload'">
      <p>Please upload the SMILES file: <input type="file" ref="upload" @change="readFile($event)"></p>
    </div>

    <div class="smiles-input-panel" v-show="step=='upload'">
      <p>or input the SMILES of all compounds:</p>
      <div class="smiles-input-container"><el-input type="textarea" :rows="10" v-model="compound"></el-input></div>
    </div>

    <div v-show="step==='submit'" class="submit-area"><submit ref="submit" :compound="compound"></submit></div>

    <div class="search-structure-buttons" v-if="stepid>=0">
      <el-button class="search-structure-prev" type="primary" v-if="stepid > 0" @click="stepid -= 1">Prev</el-button>
      <el-button class="search-structure-next" type="primary" v-if="stepid === 0" @click="next">Next</el-button>
      <el-button class="search-structure-submit" type="primary" v-if="stepid === steps.length - 1" @click="submit">Submit</el-button>
    </div>

  </div>
</div>
</template>

<script>
// import { Kekule } from 'kekule'
import axios from 'axios'
import Submit from './Submit.vue'

export default {
  name: 'BatchMode',

  data () {
    return {
      stepid: 0,
      steps: ['upload', 'submit'],
      compound: '',
      queryResult: ''
    }
  },

  components: {
    Submit
  },

  computed: {
    step () {
      return this.steps[this.stepid]
    },

    coverStyle () {
      return this.value ? {
        left: 0, right: 0, top: 0, bottom: 0
      } : {
        left: '-300%', right: '300%', top: 0, bottom: 0
      }
    }
  },

  props: [ 'value', 'query' ],

  methods: {
    isFormula (s) {
      let r = s.trim().match(/^((\(?)([A-Z])([a-z]*)([0-9]*)(\))?([0-9]*))+$/g)
      console.log('formula')
      console.log(r != null)
      return r != null
    },

    isSmiles (s, resolve, reject) {
//      let r = s.trim().match(/^([abcdefghiklmnopqrstuvwxyz0-9@+()%=#\\/$]|-|\[|\]){6,}$/ig)
//      console.log('smiles')
//      console.log(r != null)
//      return r != null
      this.smilesPromise.then(() => {
        window.SmilesDrawer.parse(s, function (tree) {
          resolve(tree)
        }, function (error) {
          reject(error)
        })
      })
    },

    readFile () {
      let v = this
      let f = arguments[0].target.files[0]
      var fr = new FileReader()
      fr.onload = function () {
        v.compound = fr.result
      }
      fr.readAsText(f)
    },

    onInput (e) {
      this.$emit('change', e)
    },

    show () {
      this.$emit('input', true)
    },

    hidden () {
      this.$emit('input', false)
    },

    next () {
      let v = this
      if (this.stepid === 1) {
        let mol = v.chemViewer.getChemObj()
        v.compound = window.Kekule.IO.saveFormatData(mol, 'smi')
      }
      v.stepid += 1
    },

    submit () {
      this.$refs.submit.submit()
      this.hidden()
    }
  },

  mounted () {
    let v = this
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.search-structure-cover {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
}

.cover-content {
  width: 1000px;
  margin: 50px auto;
  /*
  background-color: white;
  */
  position: relative;
  background-color: #dadada;
}

.cover-head {
  position: relative;
  font-size: 16px;
  padding: 10px;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.view-structure-background {
  background-color: #dadada;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
}

.view-structure {
  width: '900px'
}

.search-structure-buttons {
  width: 900px;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.search-structure-next {
  margin: 0px 20px 10px auto;
}

.search-structure-prev {
  margin: 0px auto 10px 20px;
}

.search-structure-submit {
  margin: 0px 20px 10px auto;
}

.close-button {
  margin-left: auto;
  margin-right: 0;
  z-index: 99;
  cursor: pointer;
  font-size: 20px;
  opacity: 0.5;
}

.close-button:hover {
  opacity: 1;
}

.upload-smiles {
  width: 100%;
  background-color: $theme-color;
  color: white;
  font-size: 16px;
  padding: 20px;
  box-sizing: border-box;
}

.search-input {
  margin-left: 50px;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 850px;
}

.search-input-button {
  cursor: pointer;
}

.submit-area-background {
  background-color: white;
  width: 100%;
}

.submit-area {
  width: 700px;
  margin: 0px auto;
  padding: 10px;
}

.el-button--primary {
  background-color: $theme-color;
  border-color: $theme-color;
}

.el-button--primary:hover {
  opacity: 0.5;
}

.smiles-input-panel {
  padding: 0px 20px;
  font-size: 14px;
  color: $font-grey;
}

.smiles-input-container {
  width: 80%;
  margin: 30px auto;
}

.search-result-head {
  display: flex;
  flex-direction: row;
  weight: 100%;
  padding: 10px;
  font-weight: 600;
}

.search-result-row {
  background-color: white;
  box-sizing: border-box;
  padding: 0;
  cursor: pointer;
  margin: 20px 30px 20px 30px;
}

.search-result-row:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.search-result-row-left {
  float: left;
  width: 200px;
}

.search-result-row-right {
  float: left;
  width: 600px;
  margin: 20px;
}

.search-result-pref-name {
  font-weight: 800;
}

.search-result-compound-name {
  width: 100%;
  margin-bottom: 15px;
}

.search-result-synonyms {
  width: 100%;
}

.search-result-formula {
  width: 100%;
}

.search-result-weight {
  width: 100%;
}
.search-result-smiles {
  width: 100%;
}

.search-structure-wait {
  font-size: 100px;
  height: 200px;
  vertical-align: middle;
  text-align: center;
  color: $font-grey;
}

</style>

